import(/* webpackMode: "eager" */ "/vercel/path0/src/app/books/page.jsx");
